module.exports = __webpack_public_path__ + "assets/images/project/constituencies/bukit-batok-smc.jpg?v=dd768861";